import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=905e33dc&scoped=true&"
import script from "./LayoutBase.vue?vue&type=script&lang=js&"
export * from "./LayoutBase.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBase.vue?vue&type=style&index=0&id=905e33dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905e33dc",
  null
  
)

export default component.exports